<template>
  <div :class="$style.base">
    <select 
      v-model="inputValue"
      :class="$style.value" 
    >
      <option disabled selected value="">{{selectLabel}}</option>
      <option
        v-for="(option, index) in options"
        :key="index"
        :value="option"
      >
        {{option}}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    selectLabel: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true,
      validator: options => !options.find(item => typeof item !== 'string')
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('update:value', value);
      }
    }
  }
}
</script>

<style lang="scss" module>
.base {
  position: relative;

  &:after {
    content: "";
    position: absolute;
    width: 8px;
    height: 8px;
    top: 50%;
    margin-top: -6px;
    right: $spacing;
    border-bottom: 2px solid #aaa;
    border-right: 2px solid #aaa;
    pointer-events: none;  
    transform: rotate(45deg);
  }
}

.value {
  @include input;
  cursor: pointer;
}
</style>
